module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/legal/case-registration/cr-view/cr-view.component.css
// module id = ./src/app/legal/case-registration/cr-view/cr-view.component.css
// module chunks = main